import { api } from './client';

export type EmployeeDirectoryItem = {
  id: string;
  employeeNumber: string | null;
  fullName: string;
  email: string;
  department: string | null;
  isClockedIn: boolean;
  isOnLeave: boolean;
  leaveType: string | null;
  leaveLabel: string | null;
  leaveEndDate: string | null;
};

export type EmployeeDirectoryResponse = {
  data: EmployeeDirectoryItem[];
  meta: {
    clockedInCount: number;
    onLeaveCount: number;
    totalCount: number;
  };
};

export function getEmployeeDirectory() {
  return api<EmployeeDirectoryResponse>('/employees/directory');
}
